import React from "react";
import { components } from "../../../../../api/spec";

interface ExistingMatchesSectionProps {
  manualMatches: components["schemas"]["EventCandidateSummarySchema"][];
  onRemoveMatch: (matchId: string) => void;
}

const ExistingMatchesSection: React.FC<ExistingMatchesSectionProps> = ({
  manualMatches,
  onRemoveMatch,
}) => (
  <div className="mb-8">
    <h2 className="text-3xl font-nostalgic mb-4">
      Guests manually setup so far:
    </h2>

    {manualMatches.length > 0 ? (
      <div className="space-y-3">
        {manualMatches.map((match, index) => (
          <div
            key={match.guid}
            className="flex items-center justify-between py-2"
          >
            <span className="text-white">
              {index + 1}. {match.user_1_full_name} & {match.user_2_full_name}
            </span>
            <button
              type="button"
              onClick={() => onRemoveMatch(match.guid || "")}
              className="p-1"
              aria-label="Remove match"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-white/60">No manual setups yet</p>
    )}
  </div>
);

export default ExistingMatchesSection;
